import { render, staticRenderFns } from "./EdicaoForm.vue?vue&type=template&id=2530bfa7"
import script from "./EdicaoForm.vue?vue&type=script&lang=js"
export * from "./EdicaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports